export const createBillingProvider = `
    mutation createBillingProvider($input: CreateBillingProviderInput!) {
        createBillingProvider(input:$input) {
            id
            key
            name
            description   
            status
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated  
    }
}`;

export const updateBillingProvider = `
    mutation updateBillingProvider($input: UpdateBillingProviderInput!) {
        updateBillingProvider(input:$input){
            id
            key
            name
            description
            status
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated       
        }
}`;

export const enableBillingProvider = `
    mutation enableBillingProvider($id: ID!) {
        enableBillingProvider(id: $id) {
            id
            key
            name
            description   
            status
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated  
        }
    }`;

export const disableBillingProvider = `
    mutation disableBillingProvider($id: ID!) {
        disableBillingProvider(id: $id) {
            id
            key
            name
            description   
            status
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated  
        }
    }`;

export const deleteBillingProvider = `
    mutation deleteBillingProvider($input: DeleteBillingProviderInput!) {
        deleteBillingProvider(input:$input) 
}`;
